export const pageview = (url: string): void => {
  // biome-ignore lint/style/useBlockStatements :[AUTOMATICALLY-INSERTED] Block statements are preferred in this position.
  if (window.dataLayer === undefined) return;

  window.dataLayer.push({
    event: "pageview",
    page: url,
  });
};

type GAEventParamValue = string | number | undefined | { [key: string]: GAEventParamValue };
type GAEventParam = Record<string, GAEventParamValue>;

export const event = (event: string, params?: GAEventParam): void => {
  // biome-ignore lint/style/useBlockStatements :[AUTOMATICALLY-INSERTED] Block statements are preferred in this position.
  if (window.dataLayer === undefined) return;

  window.dataLayer.push({
    event,
    ...params,
  });
};
